export default __webpack_public_path__ + "static/media/locationUnavailable.44acd327.png";